// src/lib/i18nMissingKey.ts
//
// Rend l'absence d'une clé de traduction bruyante en développement.
//
// `t(clé, { defaultValue })` renvoie silencieusement le texte par défaut quand la
// clé n'existe pas : le catalogue a ainsi pu accumuler des manques sans qu'aucune
// alerte ne se déclenche (KN-1451, KN-1452). En production, rien ne change : le
// texte par défaut reste affiché et aucun avertissement n'est émis.

const dejaSignalees = new Set<string>();

function enDeveloppement(env: string | undefined = process.env.NODE_ENV): boolean {
  return env !== "production";
}

/**
 * Écrit un avertissement unique par couple langue/clé. Sans effet en production.
 */
export function warnMissingKey(
  langues: string | readonly string[],
  cle: string,
  env?: string,
): void {
  if (!enDeveloppement(env)) return;
  const langue = typeof langues === "string" ? langues : langues.join(", ");
  const empreinte = `${langue}::${cle}`;
  if (dejaSignalees.has(empreinte)) return;
  dejaSignalees.add(empreinte);
  console.warn(`[i18n] clé de traduction manquante : "${cle}" (langue : ${langue})`);
}

/**
 * Options i18next à fusionner dans `init()`. Vide en production.
 *
 * `missingKeyHandler` n'est appelé que si `saveMissing` est vrai ; et il
 * remplace l'envoi au backend : aucune requête d'écriture n'est émise vers
 * `/locales/add/...`.
 */
export function missingKeyOptions(env?: string) {
  if (!enDeveloppement(env)) return {};
  return {
    saveMissing: true,
    missingKeyHandler: (
      langues: readonly string[],
      _ns: string,
      cle: string,
    ) => warnMissingKey(langues, cle, env),
  };
}

/** Vide la mémoire des avertissements déjà émis (tests). */
export function resetMissingKeyWarnings(): void {
  dejaSignalees.clear();
}
